import {first, catchError, mergeMap,  takeUntil, flatMap, filter, tap, map } from 'rxjs/operators';
import { RoutingHistoryService } from './../services/routingHistory.service';
import { HasChanges } from './../services/HasChanges';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subject , forkJoin, of } from "rxjs";
import { ActivatedRoute, Router, Data } from "@angular/router";
import { StreamService, TenantService, StreamSourceService, UserService } from "../services";
import { FormGroup, FormBuilder, Validators, AsyncValidatorFn, AbstractControl, ValidationErrors, FormControl } from "@angular/forms";
import * as moment from 'moment';
import * as _ from 'lodash';
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConfirmationDialogComponent } from '../general/confirmationDialog.component';
import { SelectUserDialogComponent } from '../general/selectUserDialog.component';
import { RssChangeSourceDialogComponent } from '../settings/rssChangeSourceDialog.component';
import { FactivaChangeSourceDialogComponent } from '../settings/factivaChangeSourceDialog.component';
import { BingChangeSourceDialogComponent } from '../settings/bingChangeSourceDialog.component';
import { PubmedChangeSourceDialogComponent } from '../settings/pubmedChangeSourceDialog.component';
import { ClinicalTrialsChangeSourceDialogComponent } from '../settings/clinicalTrialsChangeSourceDialog.component';
import { TwitterChangeSourceDialogComponent } from '../settings/twitterChangeSourceDialog.component';
import { ScopusChangeSourceDialogComponent } from '../settings/scopusChangeSourceDialog.component';
import { DiffbotChangeSourceDialogComponent } from '../settings/diffbotChangeSourceDialog.component';

@Component({
    styles: [`
        mat-card-content div {
            padding-top: 10px;
        }

        label.chip-label {
            color: rgba(0, 0, 0, 0.54);
            font-size: smaller;
            display: block;
            padding-bottom: 10px;
        }

        .retention-radio-group {
            display: flex;
            flex-direction: column;
            margin: 15px 0;
        }

        .retention-radio-button {
            margin: 5px;
        }
    `],
    template: `
        <div *ngIf="noTouching" fxLayout="column" fxLayoutAlign="center center" style="height:100%">
            <spinner syle="padding-top: 100px;"></spinner>
        </div>
        <mat-card *ngIf="!noTouching" [formGroup]="form">
            <mat-card-content fxLayout="column" fxFlexOffset.gt-xs="15">
                <div *ngIf="!isSource" fxLayout="row">
                    <file-upload-link (fileSelected)="fileSelected($event)">
                        <topic-image [topic]="topic"></topic-image>
                    </file-upload-link>
                </div>
                <div *ngIf="!isSource" fxLayout="row" style="padding-top: 0px;">
                    <mat-label style="font-size: 11px;">Click to set topic image</mat-label>
                </div>
                <div *ngIf="isSource" fxLayout="row">
                    <topic-image [topic]="topic"></topic-image>
                </div>
                <div fxLayout="row" *ngIf="!noPublishing">
                    <mat-slide-toggle color="primary" formControlName="published">Publish</mat-slide-toggle>
                </div>
                <div fxLayout="row" *ngIf="!noFeaturing">
                    <mat-slide-toggle color="primary" formControlName="featured">Featured</mat-slide-toggle>
                </div>
                <div>
                    <mat-form-field fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <input matInput formControlName="title" placeholder="Name">
                        <mat-error *ngIf="form.get('title').hasError('required')">Name is required</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <textarea matInput formControlName="description" placeholder="Description"></textarea>
                    </mat-form-field>
                </div>
                <div *ngIf="hasUri && topic.type === 'RSS'">
                    <div fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <mat-label class="mat-form-fieldish">{{uriTooltip}}</mat-label>
                        <div>
                            <a [href]="form?.controls.uri?.value" target="_blank">{{form?.controls.uri?.value}}</a>
                            <button mat-icon-button (click)="setUri()"><mat-icon style="font-size: 15px;">create</mat-icon></button>
                        </div>
                    </div>
                </div>
                <div *ngIf="hasUri && topic.type !== 'RSS'">
                    <mat-form-field fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <input matInput formControlName="uri" [placeholder]="uriTooltip">
                        <button mat-icon-button matSuffix (click)="setUri()"><mat-icon>create</mat-icon></button>
                    </mat-form-field>
                </div>
                <div *ngIf="hasSearch">
                    <mat-form-field fxFlex.lt-lg="200px" fxFlex.gt-md="500px">
                        <input matInput formControlName="search" placeholder="Search Term">
                        <button mat-icon-button matSuffix (click)="setSearchTerm()"><mat-icon>create</mat-icon></button>
                    </mat-form-field>
                </div>
                <div *ngIf="isSource && topic.type !== 'PRODUCT_SOURCE'">
                    <label id="retention-label" class="chip-label" style="padding-bottom: 0px;">Retention Days</label>
                    <mat-radio-group aria-labelledby="retention-label" 
                                     formControlName="retentionEnabled" 
                                     class="retention-radio-group"
                                     style="margin-top: 10px;">
                        <mat-radio-button [value]="false" class="retention-radio-button">Forever</mat-radio-button>
                        <mat-radio-button [value]="true" class="retention-radio-button">
                            Retention Days
                            <mat-form-field *ngIf="form.get('retentionEnabled').value" style="padding-left: 25px;">
                                <input matInput formControlName="itemTimeToLiveInDays" type="number" placeholder="Retention Days">
                                <mat-error *ngIf="form.get('itemTimeToLiveInDays').hasError('itemTimeToLiveInDays')">Retention Days is required</mat-error>
                            </mat-form-field>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div *ngIf="categorizationEnabled">
                    <label class="chip-label">Categories</label>
                    <topic-category-manager *ngIf="!catalogId"
                                            [topic]="topic" 
                                            (changed)="categoriesChanged = true"
                                            [catalogId]="catalogId"></topic-category-manager>
                    <catalog-topic-category-manager *ngIf="catalogId"
                                                    [topic]="topic" 
                                                    (changed)="categoriesChanged = true"
                                                    [catalogId]="catalogId"></catalog-topic-category-manager>
                </div>
                <div>
                    <label class="chip-label" style="padding-bottom: 0px;">Tags</label>
                    <topic-tag-manager [topic]="topic" 
                                       (changed)="tagsChanged = true" 
                                       [tagsUpdatedAt]="tagsUpdatedAt"
                                       [isShared]="useShared"></topic-tag-manager>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput formControlName="owner" placeholder="Owner">
                        <button mat-icon-button matSuffix (click)="selectNewOwner()"><mat-icon>create</mat-icon></button>
                    </mat-form-field>
                </div>
                <div *ngIf="!isSource">
                    <mat-slide-toggle color="primary" formControlName="rssEnabled">Enable RSS</mat-slide-toggle>
                    <a *ngIf="form.get('rssEnabled').value && topic.rssEnabled" [href]="rssUrl" style="padding-left: 20px;">{{rssUrl}}</a>
                    <span *ngIf="form.get('rssEnabled').value && !topic.rssEnabled" style="padding-left: 20px;">{{rssUrl}}</span>
                </div>
                <div *ngIf="!isSource">
                    <mat-slide-toggle color="primary" 
                                      formControlName="emailPostingEnabled"
                                      style="padding-top: 20px; padding-bottom: 20px;">Enable email posting</mat-slide-toggle>
                    <mat-form-field *ngIf="form.get('emailPostingEnabled').value" style="padding-left: 25px; width: 400px;">
                        <input matInput formControlName="emailPrefix" placeholder="Email prefix">
                        <span matSuffix>@{{streamsEmailDomain}}</span>
                        <mat-error *ngIf="form.get('emailPrefix').hasError('required')">Email prefix is required</mat-error>
                        <mat-error *ngIf="form.get('emailPrefix').hasError('pattern')">Only type the part of the email address before the @ symbol and no spaces.</mat-error>
                        <mat-error *ngIf="form.get('emailPrefix').hasError('maxLength')">Email address prefix must be shorter than 25 characters.</mat-error>            
                        <mat-error *ngIf="form.get('emailPrefix').hasError('uniqueStreamEmail')">The email address you have entered is already in use.</mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <input matInput formControlName="creator" placeholder="Creator">
                    </mat-form-field>
                </div>
                <div> 
                    <mat-form-field>
                        <input matInput formControlName="created" placeholder="CreatedDate">
                    </mat-form-field>
                </div>
                <div fxFlexOffset.gt-md="15"> 
                    <button *ngIf="!isCatalog" mat-raised-button (click)="delete()">Delete</button>
                    <button *ngIf="isCatalog" mat-raised-button (click)="removeFromCatalog()">Remove</button>
                </div>
            </mat-card-content>
            <mat-card-actions fxFlexOffset.gt-md="15">
                <button mat-raised-button color="primary" (click)="saveSettings()" [disabled]="form.invalid">Save</button>
            </mat-card-actions>
        </mat-card>
    `
})
export class EditTopicSettingsComponent implements OnInit, OnDestroy, HasChanges {
    private cleanupTime = new Subject<void>();
    private searchTypes: string[] = ['BING_SEARCH', 'TWITTER_SEARCH', 'PUBMED_SEARCH', 'CLINICALTRIALS_SEARCH', 'SCOPUS_SEARCH', 'DIFFBOT_SEARCH'];
    noTouching: boolean;
    topic: any;
    form: FormGroup;
    streamId: any;
    streamsEmailDomain: any;
    originalValue: any;
    categorizationEnabled: boolean;
    noPublishing: boolean;
    noFeaturing: boolean;
    isCurated = new FormControl();
    isSource: boolean;
    categoriesChanged: boolean;
    tagsChanged: boolean;
    tagsUpdatedAt: Date;
    catalogId: any;
    isCatalog: any;
    isShared: any;

    constructor(private route: ActivatedRoute, 
                private router: Router,
                private fb: FormBuilder,
                public snackBar: MatSnackBar,
                private dialog: MatDialog,
                private routingHistoryService: RoutingHistoryService, 
                private streamService: StreamService,
                private streamSourceService: StreamSourceService,
                private tenantService: TenantService,
                private userService: UserService) {}
    
    ngOnInit(): void {
        this.isCatalog = this.route.snapshot.data.isCatalog;        
        this.form = this.fb.group({
            published: [''],
            featured: [''],
            title: [{ value: ''}, Validators.required],
            description: [''],
            retentionEnabled: [''],
            itemTimeToLiveInDays: [''],
            rssEnabled: [''],
            emailPostingEnabled: [''],
            emailPrefix: [''],
            uri: [{value: null, disabled: true}],
            username: [''],
            password: [''],
            search: [{value: null, disabled: true}],
            apiKey: [{value: null, disabled: true}],
            insttoken: [{value: null, disabled: true}],
            apiToken: [{value: null, disabled: true}],
            bingType: [''],
            isAuthenticated: [false],
            owner: [{ value: '', disabled: true }],
            creator: [{ value: '', disabled: true }],
            created: [{ value: '', disabled: true }]
        });

        this.route.data.pipe(
            tap((data: Data) => this.isSource = data.isSource),
            tap((data: Data) => this.isShared = data.isShared),
            tap((data: Data) => this.catalogId = data.isCatalog ? this.route.parent.parent.parent.parent.snapshot.params.catalogId : undefined),
            takeUntil(this.cleanupTime))
        .subscribe();

        this.form.controls.published.valueChanges
        .pipe(
            filter(value => !value),
            tap(value => value ? this.form.controls.featured.enable() : this.form.controls.featured.disable()),
            takeUntil(this.cleanupTime)
        ).subscribe(() => this.form.get('featured').setValue(false));

        this.form.get('emailPostingEnabled').valueChanges
        .pipe(takeUntil(this.cleanupTime))
        .subscribe(emailPostingEnabled => {
            const control = this.form.get('emailPrefix');
            control.setValidators(emailPostingEnabled ? [Validators.required, Validators.maxLength(25), Validators.pattern('^[A-Za-z0-9_-]+$')] : []);
            control.setAsyncValidators(emailPostingEnabled ? [this.uniqueStreamEmail] : []);
            control.updateValueAndValidity();
        });

        this.form.get('retentionEnabled').valueChanges
        .pipe(takeUntil(this.cleanupTime)).subscribe(retentionEnabled => {
            const ctrl = this.form.get('itemTimeToLiveInDays');
            if (retentionEnabled && _.isEmpty(this.form.get('itemTimeToLiveInDays').value)) {
                ctrl.setValue(90);
            }
            ctrl.setValidators(retentionEnabled ? [Validators.required] : []); 
            ctrl.updateValueAndValidity();
        });

        this.form.get('isAuthenticated').valueChanges.pipe(takeUntil(this.cleanupTime))
        .subscribe(val => {
            const username = this.form.get('username');
            username.setValidators(val ? [Validators.required] : []);
            username.updateValueAndValidity();
        });

        this.route.parent.params
        .pipe(  
            takeUntil(this.cleanupTime),
            tap(() => this.noTouching = true),
            tap(params => this.streamId = params.topicId),
            flatMap(params => {
                const streamFetch = this.catalogId ? this.streamService.getCatalogStream(this.catalogId, params.topicId) : this.streamService.getStream(params.topicId);
                return forkJoin([
                    streamFetch, 
                    this.tenantService.getCurrentTenant()
                ])
            })  
        )
        .subscribe(([stream, tenant]) => {
            this.topic = stream;
            this.streamsEmailDomain = tenant.settings.streamsEmailDomain;
            let hideCategories = false;
            if (tenant.settings.autoTopicPublish !== 'true') {
                if (!this.userService.isCurrentUserAdmin()) {
                    this.noPublishing = true;
                    hideCategories = true;
                }
            }
            if (!stream.tenantId) {
                    this.noPublishing = true;
            }
            if (this.route.snapshot.data.hideCategories) {
                hideCategories = true;
            }
            
            this.noFeaturing = this.noPublishing || !tenant.settings.browseHeaderImageUrl;
            this.categorizationEnabled = tenant.settings.hideCategories !== 'true' && !hideCategories;
            
            this.form.patchValue({
                published: stream.published,
                featured: stream.featured,
                title: stream.title,
                description: stream.description,
                rssEnabled: stream.rssEnabled,
                retentionEnabled: !!stream.settings.itemTimeToLiveInDays,
                itemTimeToLiveInDays: stream.settings.itemTimeToLiveInDays,
                emailPostingEnabled: stream.emailPostingEnabled,
                emailPrefix: this.emailPrefix,
                uri: _.replace(stream.settings.uri, 'select.factiva.com/', ''),
                isAuthenticated: !_.isEmpty(stream.settings.username),
                username: _.replace(stream.settings.username, 'select/', ''),
                password: stream.settings.password,
                searchTerm: stream.settings.searchTerm,
                bingType: stream.settings.type,
                search: stream.settings.search,
                apiKey: stream.settings.apiKey,
                insttoken: stream.settings.insttoken,
                apiToken: stream.settings.apiToken,
                owner: stream.owner ? `${stream.owner.emailAddress}` : '',
                creator: stream.creator ? `${stream.creator.emailAddress}` : '',
                created: stream.created ? moment(stream.created).format('LL') : ''
            }, { emitEvent: false });
            this.originalValue = _.cloneDeep(this.form.value);
            this.noTouching = false;
        });
    }

    private get uniqueStreamEmail(): AsyncValidatorFn {
        return   (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => 
            this.streamSourceService.searchStreamSources('uri', control.value + '@' + this.streamsEmailDomain)
            .pipe(
                mergeMap(streamSource => streamSource.streamId === this.topic.id ? of(null) : of({ uniqueStreamEmail: { valid: false } })),
                catchError(err =>  err.status === 404 ? of(null) : of({ uniqueStreamEmail: { valid: false } }))
            );
    }

    get useShared(): boolean {
        return this.isShared || !!this.catalogId;
    }

    async saveSettings() {
        if (this.topic.newTags?.length) {
            const tags = await Promise.all(this.topic.newTags.map(tag => {
                if (this.useShared) {
                    return this.tenantService.createCatalogTag(tag).toPromise();
                } else {
                    return this.tenantService.createStreamTag(tag).toPromise();
                }
            }));
            tags.forEach((tag: { id: string, label: string }) => this.topic.tags.push(tag.id));
            this.tagsUpdatedAt = new Date();
            this.topic.newTags = undefined;
        }


        ['published', 'featured', 'title', 'description', 'rssEnabled', 'emailPostingEnabled']
        .forEach(attr => this.topic[attr] = this.form.get(attr).value);

        this.topic.settings.uri = this.topic.emailPostingEnabled ? `${this.form.get('emailPrefix').value}@${this.streamsEmailDomain}` : this.topic.settings.uri;

        if (this.topic.type === 'RSS' || this.topic.type === 'FACTIVA_SELECT_HTTP') {
            this.topic.settings.uri = (this.topic.type === 'FACTIVA_SELECT_HTTP' ? 'select.factiva.com/' : '')  + this.form.get('uri').value;
            if (this.form.get('username').value.trim().length) {
                this.topic.settings.username = (this.topic.type === 'FACTIVA_SELECT_HTTP' ? 'select/' : '')  + this.form.get('username').value;
            }
            this.topic.settings.password = this.form.get('password').value;
        }

        if (this.topic.type === 'BING_SEARCH') {
            this.topic.settings.type = this.form.get('bingType').value;
        }

        if (this.searchTypes.indexOf(this.topic.type) !== -1) {
            this.topic.settings.search = this.form.get('search').value;
        }

        const formVal = this.form.value;
        if (formVal.retentionEnabled) {
            this.topic.settings.itemTimeToLiveInDays = formVal.itemTimeToLiveInDays;
        } else {
            this.topic.settings.itemTimeToLiveInDays = undefined;
        }

        if (this.catalogId && this.categoriesChanged) {
            const deleteables = this.topic.catalogCategories.filter(catCat => catCat.isDeleted && !catCat.isNew);
            const addables = this.topic.catalogCategories.filter(catCat => catCat.isNew && !catCat.isDeleted);
            for (const catCat of deleteables) {
                await this.streamService.deleteStreamFromCatalogCategory(this.catalogId, catCat.categoryId, this.topic.id).toPromise();
            }
            for (const catCat of addables) {
                await this.streamService.addStreamToCatalogCategory(this.catalogId, catCat.categoryId, this.topic.id).toPromise();
            }
        }

        this.streamService.updateStream(this.topic).pipe(first())
        .subscribe(() => {
            this.originalValue = _.cloneDeep(this.form.value);
            this.categoriesChanged = false;
            this.tagsChanged = false;
            this.snackBar.open(`${this.topic.title} settings have been updated.`, 'OK', { duration: 3000});
            this.streamService.streamUpdated(this.topic);
        })
    }

    get rssUrl() {
        return window.location.protocol + '//' + window.location.host + '/rss/' + this.topic.id;
    }

    get emailPrefix() {
        return this.topic && this.topic.settings && this.topic.settings.uri ?
            this.topic.settings.uri.substr(0, this.topic.settings.uri.indexOf('@')) : 
            '';
    }

    hasChanges(): boolean {
        return !_.isEqual(this.form.value, this.originalValue) || 
               this.categoriesChanged || 
               this.tagsChanged ||
               this.topic.newTags?.length;
    }

    existingChangesMessage(): string {
        return `The changes to the settings for ${this.topic.title} will be lost unless saved. Continue?`;
    }

    removeFromCatalog(): void {
        const catalogId = this.route.snapshot.parent.parent.parent.parent.params.catalogId;
        this.tenantService.getCatalog(catalogId).pipe(
            map(catalog => catalog.title),
            flatMap(catalogTitle => this.dialog.open(ConfirmationDialogComponent, { 
                data: { title: `Remove ${this.topic.title} from Catalog ${catalogTitle}?`,  actionLabel: 'Remove'}}).afterClosed()),
            filter(doIt => doIt),
            flatMap(() => this.tenantService.deleteStreamFromCatalog(catalogId, this.topic.id)),
            tap(() => this.snackBar.open(`${this.topic.title} has been removed.`, 'OK', { duration: 3000}))
        ).subscribe(() => this.router.navigateByUrl(_.findLast(this.routingHistoryService.getHistory(), it => 
            it.indexOf(this.topic.id) === -1 && !it.includes('/topics/create') && !it.includes('/topics/builder')
        )));
    }

    delete(): void {
        this.dialog.open(ConfirmationDialogComponent, { 
            data: { title: `Delete ${this.topic.title}?`,  actionLabel: 'Delete'} 
        }).afterClosed().pipe(
            filter(doIt => doIt),
            flatMap(() => this.streamService.deleteStream(this.topic.id).pipe(first())),
            tap(() => this.snackBar.open(`${this.topic.title} has been deleted.`, 'OK', { duration: 3000}))
        ).subscribe(() => this.router.navigateByUrl(_.findLast(this.routingHistoryService.getHistory(), it => 
            it.indexOf(this.topic.id) === -1 && !it.includes('/topics/create') && !it.includes('/topics/builder')
        )));
    }

    selectNewOwner() {
        this.dialog.open(SelectUserDialogComponent, { data: { title: 'Select Owner'}})
        .afterClosed().pipe(first(), filter(doIt => doIt))
        .subscribe(newOwner => {
            this.form.get('owner').setValue(`${newOwner.emailAddress}`);
            this.topic.owner = newOwner;
            this.topic.ownerId = newOwner.id;
        });  
    }

    setUri() {
        let obs: Observable<any>;   
        if (this.topic.type === 'RSS') {
            obs = this.dialog.open(RssChangeSourceDialogComponent, { data: { source: this.form.getRawValue() }}).afterClosed();
        } else {
            obs = this.dialog.open(FactivaChangeSourceDialogComponent, { data: { source: this.form.getRawValue() }}).afterClosed();
        }
        obs.pipe(first(), filter(doIt => doIt))
        .subscribe(config => {
            this.form.get('uri').setValue(config.uri);
            this.form.get('username').setValue(config.username);
            this.form.get('password').setValue(config.password);
        });
    }

    setSearchTerm() {
        if (this.topic.type === 'BING_SEARCH') { 
            this.dialog.open(BingChangeSourceDialogComponent, { data: { source: this.form.getRawValue() }}).afterClosed()
            .pipe(first(), filter(doIt => doIt))
            .subscribe(config => {
                this.form.get('search').setValue(config.search);
                this.form.get('bingType').setValue(config.bingType);
            });
        } else if (this.topic.type ==='PUBMED_SEARCH') {
            this.dialog.open(PubmedChangeSourceDialogComponent, { data: { source: this.form.getRawValue() }}).afterClosed()
            .pipe(first(), filter(doIt => doIt))
            .subscribe(config => this.form.get('search').setValue(config.search));        
        } else if (this.topic.type === 'CLINICALTRIALS_SEARCH') {
            this.dialog.open(ClinicalTrialsChangeSourceDialogComponent, { data: { source: this.form.getRawValue() }}).afterClosed()
            .pipe(first(), filter(doIt => doIt))
            .subscribe(config => this.form.get('search').setValue(config.search));
        } else if (this.topic.type === 'TWITTER_SEARCH') {
            this.dialog.open(TwitterChangeSourceDialogComponent, { data: { source: this.form.getRawValue() }}).afterClosed()
            .pipe(first(), filter(doIt => doIt))
            .subscribe(config => this.form.get('search').setValue(config.search));
        } else if (this.topic.type === 'SCOPUS_SEARCH') {
            this.dialog.open(ScopusChangeSourceDialogComponent, { data: { source: this.form.getRawValue() }}).afterClosed()
            .pipe(first(), filter(doIt => doIt))
            .subscribe(config => ['search', 'apiKey', 'insttoken'].forEach(key => this.form.get(key).setValue(config[key])));
        } else if (this.topic.type === 'DIFFBOT_SEARCH') {
            this.dialog.open(DiffbotChangeSourceDialogComponent, { data: { source: this.form.getRawValue() }}).afterClosed()
            .pipe(first(), filter(doIt => doIt))
            .subscribe(config => ['search', 'apiToken'].forEach(key => this.form.get(key).setValue(config[key])));
        }
    }

    get hasUri() {
        return this.topic.type === 'RSS' || this.topic.type === 'FACTIVA_SELECT_HTTP';
    }

    get hasSearch() {
        return this.searchTypes.indexOf(this.topic.type) !== -1;
    }

    get uriTooltip() {
        return this.topic.type === 'RSS' ? 'RSS Url' : 'Folder name';
    }

    fileSelected(image) {
        this.streamService.saveImage(this.topic.id, image)
        .pipe(
            flatMap(() => this.streamService.getStream(this.topic.id)),
            tap(topic => this.topic = topic),
            tap(topic => this.streamService.streamUpdated(topic)),
        )
        .subscribe(() => this.snackBar.open(`${this.topic.title} image saved.`, 'OK', { duration: 3000}));
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
